import React from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { displayDateFormater, displayDefaultDateFormater, mustBeArray } from '../../utils/lib';
import { getClienRequestBadge } from '../../utils';
import {AUTO_TANK_SWAP_REQUEST_ID, BASE_URL, CLIENT_REQUEST_APPROVED_ID } from '../../constants';


const ClientRequestList = ({handleViewRequest, list, showRunLink, canManageRuns, handleAddToRun}) => {
    const getCollectionColumns =  () => {
            return([
                {
                    id: 'clientName',
                    Header: 'Client Name',
                    accessor: x => x.clientName,
                    Cell: row => row && row.original && row.original.clientId
                        ? <Link to={`${BASE_URL}/manage/clients/${row.original.clientId}`} target="_blank">{row.value}</Link>
                        : row && row.value
                },
                {
                    id: 'locationName',
                    Header: 'Client Location',
                    accessor: x => x.locationName,
                    Cell: row => row && row.original && row.original.locationId
                        ? <Link to={`${BASE_URL}/manage/locations/${row.original.locationId}`} target="_blank">{row.value}</Link>
                        : row && row.value
                },
                {
                    id: 'requestTypeName',
                    Header: 'Request Type',
                    accessor: x => x.requestTypeName,
                    // maxWidth: 160,
                    width: 155,
                    Cell: row => ( <div className="flex justify-content-center ">
                                    {row && row.value}
                                </div>
                    )
                },
                {
                    id: 'dateCreated',
                    Header: 'Request Date',
                    accessor: x => x.dateCreated,
                    maxWidth: 110,
                    Cell: row =>(<div className="flex justify-content-center ">{displayDateFormater({value: row && row.value})}</div>)       
                },
                {
                    id: 'createdBy',
                    Header: 'Requested By',
                    accessor: x => x.createdBy,
                    Cell: row => ( <span>
                                    {(row && row.original && row.original.requestTypeId === AUTO_TANK_SWAP_REQUEST_ID) ? 'System' : (row && row.value)}
                                </span>)
                },
                {
                    id: 'viewRequest',
                    Header: 'View Request',
                    accessor: x => x.viewRequest,
                    maxWidth: 110,
                    align: "center",
                    Cell: row => (<div className="flex text-primary justify-content-center hand"
                                        onClick={e => handleViewRequest({id: row.original && row.original.id})}
                                    >
                                        View Case
                                    </div>)
                },
                {
                    id: 'requestStatusId',
                    Header: 'Status',
                    accessor: x => x.requestStatusId,
                    maxWidth: 153,
                    minWidth: 153,
                    align: "center",
                    Cell: row => (<div className="flex justify-content-center selectableRowCheckbox">
                                            {getClienRequestBadge({statusId: row && row.value, statusName: row && row.original && row.original.requestStatusName})}
                                    </div>)
                },
                {
                    id: 'runDate',
                    Header: 'Scheduled',
                    accessor: x => x.runDate,
                    maxWidth: 100,
                    Cell: row => row && row.value ? showRunLink ? (<div className="flex text-primary justify-content-center hand">
                                <a href={`${BASE_URL}/runs/search/${row.original.runId}`}
                                   target={'_blank'}>{displayDateFormater({value: row.value})}</a></div>)
                        : (<div className="flex justify-content-center">
                                {displayDateFormater({value: row.value})}</div>)
                        : (canManageRuns && row && row.original && row.original.requestStatusId === CLIENT_REQUEST_APPROVED_ID
                            ? (<div className="flex justify-content-center">
                                    <button className="btn btn-sm btn-primary"
                                            onClick={() => handleAddToRun({locationId: row.original.locationId, requestTypeId: row.original.requestTypeId})}>
                                        Add to Run
                                    </button>
                                </div>)
                            : (<div className="flex justify-content-center "></div>))
                },
                
            ]);
    };
    return (<Card className="p-1">
                <CardTitle className="mb-2">Review Requests</CardTitle>
                <CardBody>
                    <ReactTable
                        sortable
                        filterable={false}
                        showPagination={true}
                        defaultPageSize={20}
                        data={mustBeArray(list)}
                        columns={getCollectionColumns()}
                        minRows={mustBeArray(list).length === 0 ? 5 : mustBeArray(list).length > 20 ? 20 : mustBeArray(list).length}
                        className="selectableRowTable br-1"
                    />
                </CardBody>
            </Card>);
};
export default ClientRequestList;